<template>
  <!-- 预约咨询 -->
  <div class="sale_common">
    <div class="sale_common_main">
      <!-- 预约咨询 -->
      <div class="sale_common_title">
        <!-- 标题 -->
        <h3>
          <p></p>预约咨询
        </h3>
        <!-- 星 -->
        <p>***************************************************************************************************************************************************************************************************************************************************************</p>
      </div>
      <!-- 咨询人 -->
      <div class="sale_common_consultant">
        <!-- 咨询人信息 -->
        <div class="sale_consul_msg">
          <!-- 咨询人头像 -->
          <div class="sale_header_portrait">
            <img src="../../assets/img/bicon29.png" alt>
          </div>
          <!-- 咨询人具体信息 -->
          <div class="sale_detail">
            <!-- 姓名等信息 -->
            <div class="sale_msg_detail">
              <!-- 姓名 -->
              <span class="sale_name">
                <p>王某某</p>
                <el-rate
                  v-model="value"
                  :colors="['#F56C6C', '#F56C6C', '#F56C6C']"
                  :disabled="true"
                ></el-rate>
              </span>
              <!-- 行业 从业时间 -->
              <span class="sale_shop">
                <p>蓝腾卫浴 | 北居然店</p>
                <p>
                  从业时间 |
                  <i style="color:#333;font-weight:600">5</i>
                  年
                </p>
              </span>
              <!-- 预约按钮 -->
              <span class="sale_appointment">
                <p>预约咨询</p>
              </span>
            </div>
            <!-- 评分 -->
            <div class="sale_score">
              <p>评分</p>
              <p>9.8</p>
              <p>分</p>
            </div>
          </div>
        </div>
        <div class="sale_consul_msg">
          <!-- 咨询人头像 -->
          <div class="sale_header_portrait">
            <img src="../../assets/img/bicon29.png" alt>
          </div>
          <!-- 咨询人具体信息 -->
          <div class="sale_detail">
            <!-- 姓名等信息 -->
            <div class="sale_msg_detail">
              <!-- 姓名 -->
              <span class="sale_name">
                <p>王某某</p>
                <el-rate
                  v-model="value"
                  :colors="['#F56C6C', '#F56C6C', '#F56C6C']"
                  :disabled="true"
                ></el-rate>
              </span>
              <!-- 行业 从业时间 -->
              <span class="sale_shop">
                <p>蓝腾卫浴 | 北居然店</p>
                <p>
                  从业时间 |
                  <i style="color:#333;font-weight:600">5</i>
                  年
                </p>
              </span>
              <!-- 预约按钮 -->
              <span class="sale_appointment">
                <p>预约咨询</p>
              </span>
            </div>
            <!-- 评分 -->
            <div class="sale_score">
              <p>评分</p>
              <p>9.8</p>
              <p>分</p>
            </div>
          </div>
        </div>
        <div class="sale_consul_msg">
          <!-- 咨询人头像 -->
          <div class="sale_header_portrait">
            <img src="../../assets/img/bicon29.png" alt>
          </div>
          <!-- 咨询人具体信息 -->
          <div class="sale_detail">
            <!-- 姓名等信息 -->
            <div class="sale_msg_detail">
              <!-- 姓名 -->
              <span class="sale_name">
                <p>王某某</p>
                <el-rate
                  v-model="value"
                  :colors="['#F56C6C', '#F56C6C', '#F56C6C']"
                  :disabled="true"
                ></el-rate>
              </span>
              <!-- 行业 从业时间 -->
              <span class="sale_shop">
                <p>蓝腾卫浴 | 北居然店</p>
                <p>
                  从业时间 |
                  <i style="color:#333;font-weight:600">5</i>
                  年
                </p>
              </span>
              <!-- 预约按钮 -->
              <span class="sale_appointment">
                <p>预约咨询</p>
              </span>
            </div>
            <!-- 评分 -->
            <div class="sale_score">
              <p>评分</p>
              <p>9.8</p>
              <p>分</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sale-common",
  data() {
    return {
      value: 4.6
    };
  }
};
</script>
<style scoped>
.sale_common {
  width: 1200px;
  background: #fff;
  margin-left:20px
}
.sale_common_main {
  width: 1200px;
  margin: 0 auto;
}
/* 评价 */
.sale_common_main .sale_common_title {
  
  margin-top: 25px;
}
/* 评价标题 */
.sale_common_title h3 {
  color: rgba(51, 51, 51, 1);
  text-align: left;
  font-size: 21px;
  margin-bottom: 10px;
}
.sale_common_title h3 p {
  display: inline-block;
  width: 4px;
  height: 21px;
  background: rgba(222, 7, 22, 1);
  margin:0 10px  -4px 0;
}
/* 星 */
.sale_common_title p {
  color: rgba(237, 237, 237, 1);
}
/* 咨询人 */
.sale_common_main .sale_common_consultant {
  overflow: hidden;
}
/* 咨询人信息 */
.sale_common_consultant .sale_consul_msg {
  height: 190px;
  text-align: left;
}
/* 咨询人头像 */
.sale_consul_msg .sale_header_portrait {
  width: 130px;
  float: left;
  margin-top: 45px;
}
/* 咨询人具体信息 */
.sale_consul_msg .sale_detail {
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  height: 190px;
  margin-top: 38px;
  padding-right: 120px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
/* 姓名等信息 */
.sale_detail .sale_msg_detail {
  float: left;
  width: 600px;
}
.sale_msg_detail span {
  width: 600px;
  display: inline-block;
  float: left;
}
/* 姓名 */
.sale_msg_detail .sale_name p {
  float: left;
  font-size: 18px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(85, 85, 85, 1);
  margin:0 15px 0 0;
  line-height: 20px;
}
/* 行业 从业时间 */
.sale_msg_detail .sale_shop p {
  float: left;
  margin: 16px 17px 19px 0;
  font-size: 12px;
 
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
}
/* 预约按钮 */
.sale_msg_detail .sale_appointment p {
  display: inline-block;
  width: 66px;
  height: 24px;
  background: rgba(222, 7, 22, 1);
  border-radius: 3px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
}
/* 评分 */
.sale_consul_msg .sale_score {
  float: right;
  line-height: 40px;
}
.sale_consul_msg .sale_score p {
  float: left;
  color: rgba(136, 136, 136, 1);
  margin:0
}
.sale_consul_msg .sale_score p:nth-child(2) {
  font-size: 30px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(222, 7, 22, 1);
  line-height: 23px;
  margin: 0 10px;
}
.sale_consul_msg .sale_score p:last-child {
  color: rgba(222, 7, 22, 1);
}
</style>


// WEBPACK FOOTER //
// saleSubscribe.vue?0dfcbcc1